module.exports = __webpack_public_path__ + "static/media/comment_modal_corner.0c159ebd.svg";